import CaremapprModal from '../../../../components/Modal/CaremapprModal/CaremapprModal';
import CareMapprButton from '../../../../components/Button/CareMapprButton';

interface ConsentConfirmationProps {
  show: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  onClose: () => void;
}

const ConsentConfirmation = ({
  show,
  onCancel,
  onConfirm,
  onClose,
}: ConsentConfirmationProps) => {
  return (
    <CaremapprModal
      id="chat-consent-modal"
      show={show}
      onHide={onClose}
      bodyClassName="p-0"
      body={
        <div className="d-flex h-100 flex-column justify-content-between p-4">
          <div>
            <div className="d-flex align-items-start justify-content-between gap-3 mb-3">
              <h2 className="chat-modal-title mb-0">
                Have you asked for the patient&apos;s consent?
              </h2>
              <button
                type="button"
                aria-label="Close consent modal"
                onClick={onClose}
                className="btn-close chat-modal-close shadow-none"
              />
            </div>
            <p className="chat-modal-copy mb-0">
              If you are with a patient, don&apos;t forget to ask for the
              patient&apos;s consent before starting a consultation here.
            </p>
          </div>
          <div className="d-flex gap-3 mt-4">
            <CareMapprButton
              type="button"
              variant="secondary"
              label="Cancel"
              onClick={onCancel}
              extraClassNames="w-100 my-0"
            />
            <CareMapprButton
              type="button"
              label="Start chat"
              onClick={onConfirm}
              extraClassNames="w-100 my-0"
            />
          </div>
        </div>
      }
    />
  );
};

export default ConsentConfirmation;
